exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wfh-modal-content[data-v-107b5636]{max-width:75vw}", ""]);

// exports
